// extracted by mini-css-extract-plugin
export default {"image":"SRwE31","content":"LNoWko"};